<template>
	<DropdownCustom ref="dropdownCustom" :toggleIcon="false" equalWidth>
		<div class="show-content">
			<span @click.stop="beforeQuarter"><i class="fa fa-caret-left"></i></span>
			<span>{{quarterLabel}}</span>
			<span @click.stop="afterQuarter"><i class="fa fa-caret-right"></i></span>
		</div>
		<div class="quarterChoose" slot="content">
			<Row type="flex" v-if="years.length > 1">
				<Cell>
					<div class="text-hover" :class="{selected:selectedYear===y}" @click="selectedYear=y" v-for="y in years" :key="y" style="padding: 5px 10px;">{{y}}年</div>
				</Cell>
				<Cell :flex="1" class="split-line">
					<ul class="list-item">
						<li v-for="q in 4" :key="selectedYear+'-'+q" @click="changVal(selectedYear,q)" :class="{'selected':selectedQuarter===q}">
							第{{q}}季度
						</li>
					</ul>
				</Cell>
			</Row>
			<ul class="list-item" v-else>
				<li v-for="q in 4" :key="q" @click="changVal(years[0],q)" :class="{'selected':selectedQuarter===q && selectedYear===Number(years[0])}">
					{{years[0]}}年第{{q}}季度
				</li>
			</ul>
		</div>
	</DropdownCustom>
</template>

<script>
	import {mapState} from 'vuex'
	import moment from 'moment'

	export default {
		name: "AccountQuarterChoose",
		props: {
			value: [String],
		},
		computed: {
			...mapState(['currentAccountSets']),
			years() {
				const set = new Set();
				if (this.currentAccountSets && this.currentAccountSets.enableDate) {
					set.add(Number(moment(this.currentAccountSets.enableDate).format('YYYY')));
				}
				if (this.currentAccountSets && this.currentAccountSets.currentAccountDate) {
					set.add(Number(moment(this.currentAccountSets.currentAccountDate).format('YYYY')));
				}
				set.add(new Date().getFullYear());
				return [...set].sort((a, b) => b - a);
			},
			quarterLabel() {
				if (!this.quarterDate) return '';
				const m = moment(this.quarterDate);
				const q = Math.ceil((m.month() + 1) / 3);
				return `${m.format('YYYY')}年 第${q}季度`;
			},
			selectedQuarter() {
				if (!this.quarterDate) return null;
				return Math.ceil((moment(this.quarterDate).month() + 1) / 3);
			}
		},
		data() {
			return {
				selectedYear: null,
				quarterDate: null
			}
		},
		watch: {
			quarterDate(val) {
				this.$emit('input', val);
			},
			value(val) {
				this.quarterDate = val;
				if (val) this.selectedYear = Number(moment(val).format('YYYY'));
			}
		},
		methods: {
			changVal(year, quarter) {
				// 季度末月 = quarter*3 月最后一天
				const monthIdx = quarter * 3 - 1; // 2,5,8,11
				this.quarterDate = moment({years: year, months: monthIdx, days: 1}).endOf('month').format('YYYY-MM-DD');
				this.$refs.dropdownCustom.hide();
			},
			beforeQuarter() {
				const d = moment(this.quarterDate).add(-3, 'M');
				this.quarterDate = d.format('YYYY-MM-DD');
				this.selectedYear = Number(d.format('YYYY'));
			},
			afterQuarter() {
				const d = moment(this.quarterDate).add(3, 'M');
				this.quarterDate = d.format('YYYY-MM-DD');
				this.selectedYear = Number(d.format('YYYY'));
			},
		},
		mounted() {
			if (this.value) {
				this.quarterDate = this.value;
				this.selectedYear = Number(moment(this.value).format('YYYY'));
			} else if (this.currentAccountSets && this.currentAccountSets.currentAccountDate) {
				this.quarterDate = this.currentAccountSets.currentAccountDate;
				this.selectedYear = Number(moment(this.currentAccountSets.currentAccountDate).format('YYYY'));
			} else {
				const now = moment();
				this.quarterDate = now.endOf('month').format('YYYY-MM-DD');
				this.selectedYear = now.year();
			}
		}
	}
</script>

<style lang="less">
	.show-content {
		background: @primary-color;
		color: @white-color;
		cursor: pointer;
		border-radius: @border-radius;

		span {
			padding: 5px 10px;
			display: inline-block
		}
	}

	.quarterChoose {
		overflow-y: auto;

		div.selected {
			border-bottom: 1px solid @primary-color;
			color: @primary-color;
			font-weight: bold;
		}

		.split-line {
			border-left: 1px solid @primary-color;
		}

		.list-item {
			li {
				padding: 5px 20px;

				&:hover {
					background-color: #F0F6FF;
					cursor: pointer;
				}

				&.selected {
					background: @primary-color;
					color: @white-color;
				}
			}
		}
	}
</style>